import { Component, OnInit } from '@angular/core';
import { LsMdDialog } from 'src/LSNG/components/ls-dialog/ls-dialog.service';
import { Router } from '@angular/router';
import { LoginService } from '../../service/login.service';

@Component({
  selector: 'app-offline-pop-up',
  templateUrl: './offline-pop-up.component.html',
  styleUrls: ['./offline-pop-up.component.scss']
})

export class OfflinePopUpComponent implements OnInit {

  dialog: LsMdDialog<OfflinePopUpComponent>;

  constructor(private route : Router,
    private loginService : LoginService) { }

  ngOnInit(): void {

  }

  confirm(){
    this.dialog.close({"confirmed" : true})
  }

  quit(){
    this.dialog.close({"confirmed" : false})
    // this.route.navigate(["login"]);
  }
}
